"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TargetEvent = exports.SupercedeDisplayCondition = exports.PurchaseProcess = exports.LineLevelCouponDiscDisplay = exports.ImageType = exports.AmountPercent = void 0;
var SupercedeDisplayCondition = exports.SupercedeDisplayCondition = /*#__PURE__*/function (SupercedeDisplayCondition) {
  SupercedeDisplayCondition[SupercedeDisplayCondition["Never"] = 0] = "Never";
  SupercedeDisplayCondition[SupercedeDisplayCondition["ForDifferentUnits"] = 10] = "ForDifferentUnits";
  SupercedeDisplayCondition[SupercedeDisplayCondition["ForMatchingUnits"] = 20] = "ForMatchingUnits";
  SupercedeDisplayCondition[SupercedeDisplayCondition["Always"] = 30] = "Always";
  return SupercedeDisplayCondition;
}({});
;
var LineLevelCouponDiscDisplay = exports.LineLevelCouponDiscDisplay = /*#__PURE__*/function (LineLevelCouponDiscDisplay) {
  LineLevelCouponDiscDisplay[LineLevelCouponDiscDisplay["None"] = 0] = "None";
  LineLevelCouponDiscDisplay[LineLevelCouponDiscDisplay["Percent"] = 10] = "Percent";
  LineLevelCouponDiscDisplay[LineLevelCouponDiscDisplay["Dollars"] = 20] = "Dollars";
  return LineLevelCouponDiscDisplay;
}({});
var TargetEvent = exports.TargetEvent = /*#__PURE__*/function (TargetEvent) {
  TargetEvent["Enter"] = "Enter";
  TargetEvent["Mousedown"] = "mousedown";
  TargetEvent["Keyup"] = "keyup";
  return TargetEvent;
}({});
var ImageType = exports.ImageType = /*#__PURE__*/function (ImageType) {
  ImageType[ImageType["AltImage"] = 40] = "AltImage";
  ImageType[ImageType["LineDrawing"] = 50] = "LineDrawing";
  ImageType[ImageType["PrimaryImage"] = 60] = "PrimaryImage";
  return ImageType;
}({});
var AmountPercent = exports.AmountPercent = /*#__PURE__*/function (AmountPercent) {
  AmountPercent[AmountPercent["Amount"] = 0] = "Amount";
  AmountPercent[AmountPercent["Percent"] = 1] = "Percent";
  return AmountPercent;
}({});
var PurchaseProcess = exports.PurchaseProcess = /*#__PURE__*/function (PurchaseProcess) {
  PurchaseProcess[PurchaseProcess["Standard"] = 0] = "Standard";
  PurchaseProcess[PurchaseProcess["Web2Print"] = 10] = "Web2Print";
  PurchaseProcess[PurchaseProcess["CheckoutCharge"] = 20] = "CheckoutCharge";
  PurchaseProcess[PurchaseProcess["NavInk"] = 30] = "NavInk";
  PurchaseProcess[PurchaseProcess["Kit"] = 40] = "Kit";
  PurchaseProcess[PurchaseProcess["BottleDeposit"] = 50] = "BottleDeposit";
  PurchaseProcess[PurchaseProcess["AssemblyCharge"] = 60] = "AssemblyCharge";
  PurchaseProcess[PurchaseProcess["DeliveryCharge"] = 70] = "DeliveryCharge";
  return PurchaseProcess;
}({});
//# sourceMappingURL=enums.js.map